import React, { Fragment, useMemo } from 'react';
import { Header, Tab } from 'semantic-ui-react';
import XTab from '../../common/tabs/XTab';
import CreateAssetTypeContainer from './CreateAssetTypeContainer';
import CollateralProductsContainer from './CollateralProductsContainer';
import SpotProductsContainer from './SpotProductsContainer';
import FutureProductsContainer from './FuturesProductsContainer';
import { roles } from 'constants/userRoles';
import { useAppSelector } from 'hooks/useAppSelector';
import { getUserHasAnyRole } from 'reducers/usersReducer';

const PRODUCTS_SCREEN_READ_ONLY_ROLES = [roles.RISK];

const getPanes = (isReadOnlyRole) => [
  {
    menuItem: 'Assets',
    url: 'create_asset_type',
    render: () => (
      <Tab.Pane attached={false}>
        <CreateAssetTypeContainer isReadOnlyRole={isReadOnlyRole} />
      </Tab.Pane>
    ),
  },
  {
    menuItem: 'Collateral',
    url: 'collateral',
    render: () => (
      <Tab.Pane attached={false}>
        <CollateralProductsContainer isReadOnlyRole={isReadOnlyRole} />
      </Tab.Pane>
    ),
  },
  {
    menuItem: 'Spot',
    url: 'spot_products',
    render: () => (
      <Tab.Pane attached={false}>
        <SpotProductsContainer isReadOnlyRole={isReadOnlyRole} />
      </Tab.Pane>
    ),
  },
  {
    menuItem: 'Futures',
    url: 'futures_products',
    render: () => (
      <Tab.Pane attached={false}>
        <FutureProductsContainer isReadOnlyRole={isReadOnlyRole} />
      </Tab.Pane>
    ),
  },
];

const ProductsContainer = () => {
  const isReadOnlyRole = useAppSelector((state) =>
    getUserHasAnyRole(state, PRODUCTS_SCREEN_READ_ONLY_ROLES),
  );

  const panes = useMemo(() => getPanes(isReadOnlyRole), [isReadOnlyRole]);

  return (
    <Fragment>
      <Header as="h1">Products</Header>
      <XTab panes={panes} />
    </Fragment>
  );
};

export default ProductsContainer;
